import React from 'react';
import Header from '../elements/Header';
import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';

import DifficultyAwareComponent from "../DifficultyAwareComponent";
import ListButton from '../elements/ListButton';
import ContentContainer from "../elements/ContentContainer";
import SectionHeading from "../elements/SectionHeading";
import BudgetSlider from "../elements/StepThree/BudgetSlider";
import MinistryFeedbackStatus from "../elements/StepThree/MinistryFeedbackStatus";
import BudgetCollaboration from "../elements/StepThree/BudgetCollaboration";
import PolicyElement from "../elements/StepThree/PolicyElement";
import {
  calculateBudgetPRO, calculateSavingsAndLoans,
  calculateBudgetBASIC,
} from '../../helpers/calculationsHelper';
import { getSelectedPolicyChoicesCount } from '../../helpers/policyChoiceHelper';

import Globas from "../../assets/img/icons/globas.svg";
import Beleidskeuze from "../../assets/img/icons/beleidskeuze.svg";
import connect from "react-redux/es/connect/connect";
import {__, __n} from "i18n-for-browser";
import {ministryIcons} from "../../assets/assets";
import Defines from "../../Defines";
import { gameStateInput } from '../../actions';
import { policiesForMinisterie } from '../../helpers/policyChoiceHelper';
import { getMinistryGlobasSpent } from '../../helpers/calculationsHelper';
import PopUp from '../elements/PopUp';

const { updateMyState } = gameStateInput;


/**
 * Import assets
 */
class MinistryBudget extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      ministry: this.props.match.params.id.toUpperCase(),
      allChoicesMadePopup: false,
    };
    this.maxVal = undefined;
  }

  renderLaag() {
    const { gameState, myState, dispatch, policyChoice, loaded, gameStateInput } = this.props;
    const {ministry} = this.state;
    const {
      ministerieGlobaVerdeling,
      policyChoices,
    } = myState;
    const globas = calculateBudgetBASIC(
      gameState,
      policyChoices,
      ministerieGlobaVerdeling,
      calculateSavingsAndLoans(gameStateInput),
      policyChoice,
    );
    const international = Defines.i18nMinistries.includes(ministry);

    if (!this.maxVal && loaded) {
      if ((globas + (ministerieGlobaVerdeling[ministry] || 0)) > 20) {
        this.maxVal = 20;
      } else {
        this.maxVal = globas + (ministerieGlobaVerdeling[ministry] || 0);
      }
    }
    return (
      <div>
        <Header
          match={this.props.match}
          history={this.props.history}
          historic={false}
          buttonType='close'
          viewType='list'
          showTitle={false}
          showBudget={true}/>

        <div className='container ministry-budget-container'>
          <ListButton
            ministry={ministry}
            title={__(ministry)}
            icon={ministryIcons[ministry]}
            arrow={true}
            points={false}
            globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, ministry, gameState.currentStep)}
            popupId={Defines.ministryPopupIds.pro[ministry]}
            global={Defines.i18nMinistries.includes(ministry)}
            disaster={false}
          />

          <MinistryFeedbackStatus ministry={this.state.ministry} />

          <SectionHeading
            icon={Globas}
            title={__n('sim_budgetkeuze', 1)}
            popupId={'mhgvtbudgetkeuze'}/>

          <ContentContainer>
            <h3 className={'popup-heading'}>{__("sim_vraag_hoeveel_globas_aan_ministerie")}</h3>
            {/*<PopupTitle popupId={null} tag={'h3'}/>*/}
            <BudgetSlider
              role={this.props.user.role}
              key={ministry}
              unit={__('sim_miljard')}
              disabled={globas < 0}
              value={ministerieGlobaVerdeling[ministry] || 0}
              customOnChange={(k, v) => {
                const globasLeft = globas + (ministerieGlobaVerdeling[ministry] || 0) - v;
                if (globasLeft >= 0 || v < (ministerieGlobaVerdeling[ministry] || 0)) {
                  dispatch(updateMyState({
                    ministerieGlobaVerdeling: {
                      ...ministerieGlobaVerdeling,
                      [ministry]: v,
                    },
                  }));
                  return;
                }
                if (globasLeft < 0) {
                  dispatch(updateMyState({
                    ministerieGlobaVerdeling: {
                      ...ministerieGlobaVerdeling,
                      [ministry]: (ministerieGlobaVerdeling[ministry] || 0) + globas,
                    },
                  }));
                }
              }}
              min={0}
              max={this.maxVal}
              ignoreMax={true}/>

            {international ? (
              <BudgetCollaboration
                value={ministerieGlobaVerdeling[`${ministry}SW`]}
                customOnChange={(k,v) => {
                  dispatch(updateMyState({
                    ministerieGlobaVerdeling: {
                      ...ministerieGlobaVerdeling,
                      [`${ministry}SW`]: v,
                    },
                  }));
                }}
                title={__('sim_selecteer_samenwerk_landen') + ':'}
              />
            ) : null}
          </ContentContainer>
        </div>

        <NextStep/>
      </div>
    );
  }

  renderHoog() {
    const { gameStateInput, gameState, myState, dispatch, policyChoice, loaded } = this.props;
    const {ministry} = this.state;
    const {
      ministerieGlobaVerdeling,
      policyChoices,
    } = myState;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetPRO(gameState, gameStateInput, policyChoices, myState.ministerieGlobaVerdeling, savingsAndLoans);
    const international = Defines.i18nMinistries.includes(ministry);
    if (!this.maxVal && loaded) {
      if ((globas + (ministerieGlobaVerdeling[ministry] || 0)) > 100) {
        this.maxVal = 100;
      } else {
        this.maxVal = globas + (ministerieGlobaVerdeling[ministry] || 0);
      }
    }

    return (
      <div>
        <Header
          history={this.props.history}
          match={this.props.match}
          historic={false}
          buttonType='close'
          viewType='list'
          showTitle={false}
          showBudget={true}/>

        <div className='container ministry-budget-container'>
          <ListButton
            ministry={ministry}
            title={__(ministry)}
            icon={ministryIcons[ministry]}
            arrow={true}
            stars={Defines.ministeryStars[ministry]}
            points={false}
            globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, ministry, gameState.currentStep, Object.values(policyChoices))}
            popupId={Defines.ministryPopupIds.pro[ministry]}
            global={Defines.i18nMinistries.includes(ministry)}
            disaster={false}
          />

          <MinistryFeedbackStatus ministry={this.state.ministry} />

          <SectionHeading
            icon={Globas}
            title={__n('sim_budgetkeuze', 1)}
            popupId={'mhgvtbudgetkeuze'}/>

          <ContentContainer className={'pro-no-margin-slider'}>
            <BudgetSlider
              role={this.props.user.role}
              unit={__('sim_miljard')}
              disabled={globas < 0}
              value={ministerieGlobaVerdeling[ministry] || 0}
              customOnChange={(k, v) => {
                const globasLeft = globas + (ministerieGlobaVerdeling[ministry] || 0) - v;
                if (globasLeft >= 0 || v < (ministerieGlobaVerdeling[ministry] || 0)) {
                  dispatch(updateMyState({
                    ministerieGlobaVerdeling: {
                      ...ministerieGlobaVerdeling,
                      [ministry]: v,
                    },
                  }));
                  return;
                }
                if (globasLeft < 0) {
                  dispatch(updateMyState({
                    ministerieGlobaVerdeling: {
                      ...ministerieGlobaVerdeling,
                      [ministry]: (ministerieGlobaVerdeling[ministry] || 0) + globas,
                    },
                  }));
                }
              }}
              min={0}
              max={this.maxVal}
              ignoreMax={true}/>

            {international ? (
              <BudgetCollaboration
                value={ministerieGlobaVerdeling[`${ministry}SW`]}
                customOnChange={(k,v) => {
                  dispatch(updateMyState({
                    ministerieGlobaVerdeling: {
                      ...ministerieGlobaVerdeling,
                      [`${ministry}SW`]: v,
                    },
                  }));
                }}
                title={__('sim_selecteer_samenwerk_landen') + ':'}
              />
            ) : null}
          </ContentContainer>

          <SectionHeading
            icon={Beleidskeuze}
            title={__n('sim_beleidskeuze', 1)}
            popupId={'mhgvtbeleidskeuzes'}/>

          {policiesForMinisterie(policyChoice, ministry).map(
            (choice, key) => (
              <PolicyElement
                key={ministry + choice.Nummer + key}
                title={choice[`titel_beleidskeuze_${gameState.language}`]}
                globas={parseInt(choice.kosten_globas[0], 10)}
                collaborationGlobas={choice.kosten_globas.length > 1 ? parseInt(choice.kosten_globas[1], 10) : 0}
                value={policyChoices[choice.omschrijving] || {}}
                onChange={(v) => {
                  if(v.selected === false) {
                    delete policyChoices[choice.omschrijving];
                    dispatch(updateMyState({
                      policyChoices: policyChoices,
                    }))
                  } else {
                    const newPolicyChoices = { ...policyChoices, [choice.omschrijving]:{...v, ministry, nummer: choice.Nummer} };
                    const numChoices = getSelectedPolicyChoicesCount(newPolicyChoices);
                    if (numChoices > 10) {
                      this.setState({ allChoicesMadePopup: true });
                      return;
                    }
                    if (v.option && globas - v.globas < 0) {
                      return;
                    }
                    this.maxVal = undefined;
                    dispatch(updateMyState({
                      policyChoices: newPolicyChoices,
                    }))
                  }
                }}
              >
                {choice[`tekst_beleidskeuze_${gameState.language}`]}
              </PolicyElement>
            )
          )}

        </div>

        { this.state.allChoicesMadePopup ? (
          <PopUp interactive closePopUpCross closePopUpClick={() => { this.setState({ allChoicesMadePopup: false }); }}>
            {__('sim_maximum_beleidskeuzes_bereikt')}
          </PopUp>
        ) : null }

        <NextStep/>
      </div>
    );
  }
}

export default connect(({user, gameState, feedback, gameStateInput, policyChoice, project}) => ({user, policyChoice, gameState, feedback, project, loaded: gameStateInput.loaded, myState: gameStateInput.myState, gameStateInput}))(MinistryBudget);



// WEBPACK FOOTER //
// ./src/components/routes/MinistryBudget.js